import { AssessmentState } from './assessment-wrapper.model';

export class ErrorInfo {
  state: AssessmentState;
  translationKey: string;
}
